import { render, staticRenderFns } from "./ModalReviewCreate.vue?vue&type=template&id=29e1821e&scoped=true"
import script from "./ModalReviewCreate.vue?vue&type=script&lang=js"
export * from "./ModalReviewCreate.vue?vue&type=script&lang=js"
import style0 from "./ModalReviewCreate.vue?vue&type=style&index=0&id=29e1821e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e1821e",
  null
  
)

export default component.exports